import React, { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { setAOL } from 'redux/actions/aol'
import { setQAPickedSection } from 'redux/actions/qa'
import { setAccordionTextFragment } from 'redux/actions/accordion'
import AccordionWrapperContainer from 'redux/containers/components/accordion/AccordionWrapperContainer'

export default function QaContent (props) {
  const dispatch = useDispatch()
  const { aol, sections, flavour, routePageId, textFragment } = props
  const previousRoutePageId = useRef(null)

  useEffect(() => {
    dispatch(setAOL(aol))

    return () => {
      dispatch(setAOL(null))
    }
  }, [aol, dispatch])

  useEffect(() => {
    if (previousRoutePageId.current === routePageId) return
    previousRoutePageId.current = routePageId
    dispatch(setAccordionTextFragment(textFragment || null))
  }, [routePageId, textFragment, dispatch])

  useEffect(() => {
    return () => {
      dispatch(setAccordionTextFragment(null))
    }
  }, [dispatch])

  useEffect(() => {
    if (sections && flavour && sections.nodes) {
      dispatch(setQAPickedSection(flavour, { [flavour]: sections }))
    }
  }, [sections, flavour, dispatch])

  return (
    <AccordionWrapperContainer {...props} />
  )
}
